export {};
//# sourceMappingURL=IParticleEmitterType.js.map